import { createContext } from "react"

const pinContext = createContext()

export default pinContext
